module.exports = __webpack_public_path__ + "static/media/icon-delete.643d8392.svg";